export const DEFAULT_GEOFENCE_RADIUS_M = 100;
export const MIN_GEOFENCE_RADIUS_M = 25;
export const MAX_GEOFENCE_RADIUS_M = 500;
export const GEOFENCE_REGION_PADDING = 1.4;

export type GeofenceCircle = {
  center: { lat: number; lng: number };
  radius: number;
};

export function hasGeofenceCoords(
  lat?: number | null,
  lng?: number | null,
): boolean {
  return (
    typeof lat === "number" &&
    Number.isFinite(lat) &&
    typeof lng === "number" &&
    Number.isFinite(lng)
  );
}

export function clampGeofenceRadius(value: number): number {
  if (!Number.isFinite(value)) {
    return DEFAULT_GEOFENCE_RADIUS_M;
  }
  return Math.min(
    MAX_GEOFENCE_RADIUS_M,
    Math.max(MIN_GEOFENCE_RADIUS_M, Math.round(value)),
  );
}

export function geofenceCircle(
  lat: number,
  lng: number,
  radiusM: number,
): GeofenceCircle {
  return {
    center: { lat, lng },
    radius: clampGeofenceRadius(radiusM),
  };
}

export function regionForGeofence(lat: number, lng: number, radiusM: number) {
  const diameterM = clampGeofenceRadius(radiusM) * 2 * GEOFENCE_REGION_PADDING;
  const latitudeDelta = Math.max(diameterM / 111_320, 0.002);
  const longitudeDelta = Math.max(
    diameterM / (111_320 * Math.cos((lat * Math.PI) / 180)),
    0.002,
  );
  return {
    center: { lat, lng },
    latitudeDelta,
    longitudeDelta,
  };
}

export function zoomForGeofenceRadius(radiusM: number): number {
  const radius = clampGeofenceRadius(radiusM);
  if (radius <= 40) return 18;
  if (radius <= 80) return 17;
  if (radius <= 150) return 16;
  if (radius <= 300) return 15;
  return 14;
}

export function readPrimaryCssColor(): string | null {
  if (typeof window === "undefined") {
    return null;
  }

  const styles = window.getComputedStyle(document.documentElement);
  const value =
    styles.getPropertyValue("--color-primary").trim() ||
    styles.getPropertyValue("--tk-primary").trim();
  return value || null;
}
